import React, { useState } from "react";
import { toast } from "react-toastify";
import { descargarArchivoIntercambio, auditarArchivoIntercambioExportado, } from "../../../../services/historiaClinica";

const ModalArchivoIntercambio = ({
  isOpen,
  onClose,
}) => {
  const getFechaLocal = () => {
    const hoyLocal = new Date();
    const year = hoyLocal.getFullYear();
    const month = String(hoyLocal.getMonth() + 1).padStart(2, "0");
    const day = String(hoyLocal.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const hoy = getFechaLocal();

  const [fechaInicio, setFechaInicio] = useState(hoy);
  const [fechaFin, setFechaFin] = useState(hoy);
  const [exportando, setExportando] = useState(false);

  if (!isOpen) return null;

  const validarFechas = () => {
    if (!fechaInicio || !fechaFin) {
      toast.error("Selecciona fecha inicio y fecha fin.");
      return false;
    }

    if (fechaInicio > hoy || fechaFin > hoy) {
      toast.error("No puedes exportar fechas futuras.");
      return false;
    }

    if (new Date(fechaInicio) > new Date(fechaFin)) {
      toast.error("La fecha inicio no puede ser mayor a la fecha fin.");
      return false;
    }

    return true;
  };

  const descargarRespuesta = (response, nombreDefault) => {
    const url = window.URL.createObjectURL(response.data);

    const link = document.createElement("a");
    link.href = url;

    const contentDisposition = response.headers["content-disposition"];

    let nombreArchivo = nombreDefault;

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="([^"]+)"/);

      if (match?.[1]) {
        nombreArchivo = match[1];
      }
    }

    link.setAttribute("download", nombreArchivo);

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);
  };

  // Cuando la descarga falla, el backend manda {"error": "..."},
  // pero como pedimos un archivo (blob), hay que leerlo como texto.
  const obtenerMensajeError = async (error) => {
    const data = error?.response?.data;

    if (data instanceof Blob) {
      try {
        const texto = await data.text();
        const json = JSON.parse(texto);
        if (json?.error) return json.error;
      } catch {
        // No era JSON; usamos el mensaje genérico.
      }
    } else if (data?.error) {
      return data.error;
    }

    return "No se pudo generar el archivo de intercambio.";
  };

  const handleExportar = async (formato) => {
    if (!validarFechas()) return;

    try {
      setExportando(true);

      const response = await descargarArchivoIntercambio(
        fechaInicio,
        fechaFin,
        formato
      );

      descargarRespuesta(
        response,
        generarNombreArchivo(fechaFin, formato)
      );

      // Solo se audita si el archivo sí se generó y descargó.
      await auditarArchivoIntercambioExportado({
        fechaInicio,
        fechaFin,
        formato,
      });

      onClose();
    } catch (error) {
      const mensaje = await obtenerMensajeError(error);
      toast.error(mensaje, { autoClose: 8000 });
    } finally {
      setExportando(false);
    }
  };

  const generarNombreArchivo = (fechaFin, formato) => {
  const [anio, mes] = fechaFin.split("-");
  const anioCorto = anio.slice(-2);

  return `CEX-DFSSA-${anioCorto}${mes}.${formato}`;
};

  return (
    <div className="modal-overlay">
      <div className="modal-content modal-hoja-diaria">
        <div className="modal-header">
          <h3>Archivo de intercambio</h3>
        </div>

        <div className="modal-body">
          <p style={{ marginTop: 0 }}>
            Selecciona el periodo de consultas que quieres incluir.
          </p>

          <div className="form-group">
            <label>Fecha inicio</label>
            <input
              type="date"
              value={fechaInicio}
              max={hoy}
              onChange={(e) => setFechaInicio(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Fecha fin</label>
            <input
              type="date"
              value={fechaFin}
              max={hoy}
              onChange={(e) => setFechaFin(e.target.value)}
            />
          </div>
        </div>

        <div className="modal-actions">
          <button
            type="button"
            className="btn-secundario"
            onClick={onClose}
            disabled={exportando}
          >
            Atrás
          </button>

          {/*<button
            type="button"
            className="btn-primario"
            onClick={() => handleExportar("txt")}
            disabled={exportando}
          >
            {exportando ? "Generando..." : "Descargar TXT"}
          </button>*/}

          <button
            type="button"
            className="btn-secundario"
            onClick={() => handleExportar("cif")}
            disabled={exportando}
          >
            {exportando ? "Generando..." : "Descargar archivo de intercambio (cifrado)"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalArchivoIntercambio;